import './error-view.scss';

import React from 'react';

interface IProp {
  error?: string;
}

export function ErrorView({ error }: IProp) {
  return (
    <div className="error-view">
      <h1>500</h1>
      Unexpected error
      {error && error.length && <>: {error}</>}
    </div>
  );
}
